import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';

import { DecimalPipe } from '@angular/common';
import { importProvidersFrom } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { UiDatepickerModule } from '@mitsubishi/ui/datepicker';

import { NgSelectModule } from '@ng-select/ng-select';

import { markedOptionsFactory } from './marked-options';

export const provideUiConfigs = () => {
  return [
    DecimalPipe,
    provideAnimationsAsync(),
    { provide: MAT_TABS_CONFIG, useValue: { stretchTabs: false } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    importProvidersFrom(UiDatepickerModule, NgSelectModule, LazyLoadImageModule), // Necessary to make component work inside material dialog
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: markedOptionsFactory,
      },
    }),
  ];
};
